import { Outlet, useLocation } from 'react-router-dom';
import { cn } from '../../utils/cn';
import { Footer } from './Footer';
import { PageSubnav } from './PageSubnav';

export function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <div className="flex min-h-[100dvh] flex-col bg-[#fafafa]">
      <main
        className={cn(
          'flex-1',
          'pb-[calc(6.25rem+env(safe-area-inset-bottom,0px))] sm:pb-[calc(5.75rem+env(safe-area-inset-bottom,0px))]',
          isHome && 'flex min-h-0 flex-col',
        )}
      >
        <PageSubnav />
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
